import { render, staticRenderFns } from "./SkupNavigation.vue?vue&type=template&id=79624ade&scoped=true&"
import script from "./SkupNavigation.vue?vue&type=script&lang=js&"
export * from "./SkupNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79624ade",
  null
  
)

export default component.exports